import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorToken", "colorTokenArgs"];
import React from 'react';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
var ErrorWrapper = _ref => {
  var {
      colorToken,
      colorTokenArgs
      /**
       * @deprecated props spreading for this component will be removed with v6.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var designContext = useDesignContext(defaultColorVariables);
  return /*#__PURE__*/React.createElement(Surface, _extends({
    height: 20,
    width: 20
  }, props), /*#__PURE__*/React.createElement(Shape, {
    d: "M1,10a9,9 0 1,0 18,0a9,9 0 1,0 -18,0",
    fill: designContext.get(colorToken, colorTokenArgs).toString()
  }));
};
ErrorWrapper.displayName = 'FeedbackStateIconErrorWrapper';
export default withProvisionalOverrideFromContext(ErrorWrapper);
//# sourceMappingURL=index.js.map